import { render, staticRenderFns } from "./tenet.vue?vue&type=template&id=8f0618c0&scoped=true"
import script from "./tenet.vue?vue&type=script&lang=ts"
export * from "./tenet.vue?vue&type=script&lang=ts"
import style0 from "./tenet.vue?vue&type=style&index=0&id=8f0618c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0618c0",
  null
  
)

export default component.exports